import { OUTCOMES } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

export default function OutcomeSection() {
  return (
    <section id="soluzioni" className="relative bg-brand-graphite py-20 lg:py-32 grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <SectionHeading dark eyebrow={OUTCOMES.eyebrow} title={OUTCOMES.title} />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {OUTCOMES.modules.map((m, i) => (
            <Reveal key={m.num} delay={i % 3}>
              <div
                data-testid={`outcome-module-${m.num}`}
                className="group relative h-full rounded-sm border border-brand-ivory/12 bg-brand-ivory/[0.03] p-8 transition-all duration-300 hover:border-brand-gold/50 hover:-translate-y-1 hover:bg-brand-ivory/[0.06]"
              >
                <span className="font-serif text-5xl text-brand-gold/30 transition-colors group-hover:text-brand-gold/60">
                  {m.num}
                </span>
                <h3 className="mt-4 font-serif text-2xl text-brand-ivory">{m.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-ivory/65">{m.body}</p>
                <div className="mt-6 pt-4 border-t border-brand-ivory/10">
                  <span className="text-[10px] uppercase tracking-editorial font-semibold text-brand-gold">
                    Output
                  </span>
                  <p className="mt-2 font-mono text-xs text-brand-ivory/55">{m.output}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
